module.exports = __webpack_public_path__ + "static/new2-4cd7fd2edfbcf70c3e9bae3fc3df456c.jpeg";